<section class="biografia mt-4 mb-4" id="nosotros">
  <div class="container mt-4 mb-4">
    <h2 class="biografia-title mt-4 mb-4">Biografía</h2>
    <div class="biografia-content">
      <p>
        Somos un grupo que transita el repertorio folklórico argentino con la libertad de unir temas
        de autoría propia a los grandes compositores de todas las épocas a través de ritmos característicos
        y de propuestas contemporáneas. <br>
        Con un lenguaje sonoro basado en arreglos propios para las voces y
        una rica instrumentación que incluye guitarras, bajo eléctrico, piano, charango, ukulele , vientos
        y percusión, genera un espacio de expresión artística con fundamentos clásicos y una perspectiva
        joven y renovadora haciendo de cada presentación de TROPILLEROS en una invitación abierta a disfrutar,
        bailando o escuchando, un encuentro con la música popular argentina.<br>
      </p>
      <p>
        En 2019 presentamos nuestro primer disco titulado “Tropilleros” el cual se puede encontrar en
        todas las plataformas digitales.<br>
        Con 10 años recorriendo escenarios, radios, televisión, tales como:<br>
        • Festejos por el Bicentenario de la Independencia (Bs. As.)<br>
        • Festejos por los 130 años de Av. de Mayo (Bs. As.)<br>
        • Buenos Aires celebra Polonia (Bs. As.)<br>
        • Virtual Book Fair Uk (Reino Unido)<br>
        • Presentación de Disco en Teatro Sagrado Corazón (Florencio Varela-Bs. As.)<br>
        • Aniversario 60 del municipio de Berazategui<br>
        • Teatro de Quilmes (Quilmes-Bs. As.)<br>
        • Teatro de Cervantes (Quilmes-Bs. As.)<br>
        • Peña Los Cardones (Palermo-Bs. As.)<br>
        • Grupo invitado en Pre Cosquín sede Florencio Varela 2019 (Florencio Varela-
        Bs. As.)<br>
        • Carnavales del Norte (Florencio Varela-Bs. As.)<br>
        • Fiesta de la Frutilla (Florencio Varela-Bs. As.)<br>
        • Fiesta Tradicionalista Fortín La Tropilla (Florencio Varela-Bs. As.)<br>
        • Fiesta de la Miel (Florencio Varela-Bs. As.)<br>
        • Fiesta de la Pachamama (Florencio Varela-Bs. As.)<br>
        • Recorriendo peñas y fiestas de Pergamino, Concordia, Miramar, Navarro, Avellaneda<br>
        • Fiesta de la Torta Negra (Navarro)<br>
        • Fiesta del Tambero (Navarro)<br>
        • Fiesta del asado (Moquehuá)<br>
        • Expo Laboulaye (Cordoba)<br>
        • Aniversario 159 de Jeppener (Bs. As)<br>
        • Festejos por el Bicentenario de la Independencia (Bs. As.)<br>
        • El Gaucho y la Gente (Argentinísima Satelital)<br>
        • Radio 10 (AM 710)<br>
        • Radio Nacional Bs. As. (AM 870)<br>
        • Radio Top music 5 2 online (Colombia)<br>
        • Radio Ahijuna (FM 94.7)<br>
        • La hora de la nada (Radio Zonica)<br>
        • Radio Onda Latina (AM 1010)<br>
        • Radio Municipal Florencio Varela (FM 87.9)<br>
        Entre otros... <br>
      </p>
      <p>
        Conoce nuestra historia y acompáñanos en cada show.<br>
      </p>
    </div>
  </div>
</section>